import Matpel from "../../../../../components/categories/siakad/lms/data_matpel_guru_yes/Home";
export default function Home() {
  
  return (
    <Matpel />
  );
}
